import { z } from 'zod'

export const GetDataWrapperSchema = <T extends z.ZodType>(dataSchema: T) =>
  z
    .object({
      data: dataSchema,
    })
    .transform(({ data }) => {
      if (data === null || data === undefined) {
        throw new Error('Data is null or undefined')
      }
      return data
    })
